/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IDefaBusinessSignUpResources } from '.';
import BusinessSignUpItemDepartment from '../../themes/defa-theme/views/components/business-sign-up-item.department';

import { IBusinessSignUpItem, IBusinessSignUpViewProps } from './defa-business-sign-up';

const BusinessSignUpItem: React.FC<IBusinessSignUpItem  & { resources: IDefaBusinessSignUpResources }> = ({ wrapper, label, errorMessage, input, isAddressInput, resources }) => {
    const reactLabel = label as React.ReactElement | undefined;

    // Hide label and error message if rendering address section
    return (
        <Node {...wrapper}>
            {!isAddressInput && (reactLabel?.props.id === 'Department'
                ? React.cloneElement(reactLabel, { text: resources.organizationIdLabel })
                : label)}
            {input}
            {!isAddressInput && errorMessage}
        </Node>
    );
};

const BusinesSignUpView: React.FC<IBusinessSignUpViewProps & { resources: IDefaBusinessSignUpResources }> = props => {
    const { businessSignUp, ContainerWrapper, heading, description, businessSignUpForm } = props;

    const { FormWrapper, buttons, items, errorMessage, disclaimer } = businessSignUpForm;

    return (
        <Module {...businessSignUp}>
            <Node {...ContainerWrapper}>
                {heading}
                {description}
                <Node {...FormWrapper}>
                    {items &&
                        items.map((item: IBusinessSignUpItem) => {
                            switch (item.id) {
                                case 'Department':
                                    return (
                                        <BusinessSignUpItemDepartment
                                            key={item.id}
                                            context={props.businessSignUp.moduleProps.context}
                                            {...item}
                                            {...props}
                                            inputId={item.id}
                                        />
                                    );
                                default:
                                    return (
                                        <BusinessSignUpItem
                                            key={item.id}
                                            {...item}
                                            {...props}
                                        />
                                    );
                            }
                        })}
                    {errorMessage &&
                        errorMessage.map((error: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{error}</React.Fragment>;
                        })}
                    {buttons &&
                        buttons.map((button: React.ReactNode, index: number) => {
                            return <React.Fragment key={index}>{button}</React.Fragment>;
                        })}
                    {disclaimer}
                </Node>
            </Node>
        </Module>
    );
};

export default BusinesSignUpView;
